module.exports = __webpack_public_path__ + "static/media/c52-wifi.5975baf1.png";